import React, { useEffect, useMemo, useState } from 'react';
import { withRouter } from "react-router-dom";
import DataTable from 'react-data-table-component';
import moment from 'moment';
import ReportsV2 from '../Services/ReportsV2';
import Alert from '../Services/Alert';
import { getDateFormat } from '../Services/Custom';

const CURRENCY = process.env.REACT_APP_CURRENCY_SYMBOL || '₹';
const money = (v) => `${CURRENCY}${Number(v || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** Audit trail of admin edits to placed bids: what it was, what it became, and who changed it. */
export const BidUpdateReport = (props) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [search, setSearch] = useState('');
    const [searchFromDate, setSearchFromDate] = useState('');
    const [searchToDate, setSearchToDate] = useState('');
    const [isReset, setIsReset] = useState(false);

    const columns = useMemo(() => [
        { name: 'Changed at', selector: row => moment(row.createdAt).format('DD-MM-YYYY hh:mm A'), width: '175px' },
        { name: 'Mobile', selector: row => row.mobile_no || '-', width: '130px' },
        { name: 'Market', selector: row => row.market_name || '-', wrap: true },
        { name: 'Game', selector: row => row.game_label || '-', wrap: true },
        { name: 'Was', selector: row => row.previous_value || '-', width: '100px' },
        { name: 'Changed to', selector: row => row.new_value || '-', width: '110px' },
        { name: 'Amount', selector: row => money(row.amount), right: true, width: '110px' },
        { name: 'Changed by', selector: row => row.updated_by_name || '-', wrap: true },
    ], []);

    function fetchReport(page, size = perPage) {
        setLoading(true);
        ReportsV2.bidUpdates({ page, size, search, searchFromDate, searchToDate }).then(resp => {
            const r = resp.data;
            if (r.status == 1) { setData(r.data.docs); setTotalRows(r.total); }
            else Alert.error(r.message);
            setLoading(false);
        }).catch(err => { setLoading(false); Alert.error(err.message); });
    }

    useEffect(() => { fetchReport(1); }, [isReset]);

    return (
        <section className="main-content marketadd_main_sec">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title mb-1">Bid Update Report</h4>
                                    <p className="text-muted">
                                        Every admin edit to a placed bid, with the value before and after.
                                        Recording started when this report was deployed &mdash; edits made before
                                        that were never logged and cannot be shown here.
                                    </p>

                                    <div className="border border-primary p-3 mb-4">
                                        <div className="row">
                                            <div className="col-lg-2">
                                                <label className="form-label">From</label>
                                                <input type="date" className="form-control" max={getDateFormat()}
                                                    value={searchFromDate} onChange={e => setSearchFromDate(e.target.value)} />
                                            </div>
                                            <div className="col-lg-2">
                                                <label className="form-label">To</label>
                                                <input type="date" className="form-control" max={getDateFormat()} min={searchFromDate}
                                                    value={searchToDate} onChange={e => setSearchToDate(e.target.value)} />
                                            </div>
                                            <div className="col-lg-4">
                                                <label className="form-label">Search (mobile no.)</label>
                                                <input type="text" className="form-control" value={search}
                                                    onChange={e => setSearch(e.target.value)}
                                                    onKeyDown={e => { if (e.key === 'Enter') setIsReset(!isReset); }} />
                                            </div>
                                            <div className="col-lg-4 d-flex align-items-end">
                                                <button className="btn btn-primary me-2" onClick={() => setIsReset(!isReset)}>Filter</button>
                                                <button className="btn btn-light" onClick={() => { setSearch(''); setSearchFromDate(''); setSearchToDate(''); setIsReset(!isReset); }}>Reset</button>
                                            </div>
                                        </div>
                                    </div>

                                    <DataTable
                                        columns={columns} data={data} progressPending={loading}
                                        noDataComponent={<div className="p-4 text-muted">No bid edits recorded yet.</div>}
                                        pagination paginationServer paginationTotalRows={totalRows}
                                        onChangeRowsPerPage={(n, p) => { setPerPage(n); fetchReport(p, n); }}
                                        onChangePage={(p) => fetchReport(p)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default withRouter(BidUpdateReport);
